'use client';

import React, { useState } from 'react';
import type { PartnerReview } from '@/content/reviews';
import { PartnerReviewCard } from './PartnerReviewCard';
import styles from '../../app/[locale]/reviews/reviews.module.css';
import reviewSectionStyles from './ReviewSection.module.css';

interface PartnerReviewsGridProps {
  reviews: PartnerReview[];
  currentLocale: 'en' | 'nl' | 'de';
  translations: {
    readMore: string;
    showLess: string;
    viewIntegration: string;
    showAll?: string;
    showLessReviews?: string;
  };
  initialVisibleCount?: number;
}

export function PartnerReviewsGrid({ 
  reviews, 
  currentLocale, 
  translations,
  initialVisibleCount = 6 
}: PartnerReviewsGridProps) {
  const [allExpanded, setAllExpanded] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const shouldShowButton = reviews.length > initialVisibleCount;

  const handleToggle = () => {
    setAllExpanded(!allExpanded);
  };

  return (
    <>
      <div className={styles.partnerReviewGrid} data-show-all={showAll}>
        {reviews.map((review, index) => (
          <div key={`partner-${index}`} className={styles.reviewCardWrapper}>
            <PartnerReviewCard
              review={review}
              currentLocale={currentLocale}
              translations={translations}
              isExpanded={allExpanded}
              onToggle={handleToggle}
            />
          </div>
        ))}
      </div>
      
      {shouldShowButton && translations.showAll && translations.showLessReviews && (
        <div className={reviewSectionStyles.buttonWrapper}>
          <button
            onClick={() => setShowAll(!showAll)}
            className={reviewSectionStyles.showAllButton}
          >
            {showAll ? translations.showLessReviews : translations.showAll}
          </button>
        </div>
      )}
    </>
  );
}

